// toGetCurrentUser.js

import { getCurrentUser } from '@/apis/currentUser';
import { getScholarInfo } from '@/apis/scholar';

export default {
  state: {
    isLoginKey: 0,
    currentUser: {},
    scholar_level: 0,
    currentUserInfo: {},
  },
  mutations: {
    AddCurrentUser(state, payload) {
      // localStorage.setItem('currentUser',val)
      state.currentUser = payload;
    },
    AddIsLogin(state, payload) {
      // localStorage.setItem('isLoginKey',val)
      state.isLoginKey = payload;
    },
    AddScholarLevel(state, payload) {
      // localStorage.setItem('isLoginKey',val)
      state.scholar_level = payload;
    },
    AddCurrentUserInfo(state, payload) {
      // localStorage.setItem('currentUserInfo',val)
      state.currentUserInfo = payload;
    },
  },
  actions: {
    toGetCurrentUser(context) {
      if (
        localStorage.eleToken !== null &&
        localStorage.eleToken !== '' &&
        localStorage.eleToken !== undefined
      ) {
        getCurrentUser()
          .then((res) => {
            if (res.status === 200) {
              if (res.data.success === true) {
                context.commit('AddIsLogin', 1);
                context.commit('AddCurrentUser', res.data.data?.item);
                console.log(
                  '用户信息',
                  context.state.currentUser,
                  context.state.isLoginKey,
                );
              } else {
                this.$message.error(res.data.message);
                context.commit('AddIsLogin', 0);
              }
            } else {
              context.commit('AddIsLogin', 0);
              this.$message.error('未请求成功');
              console.log('错误');
            }
          })
          .catch((error) => {
            console.log(error);
            context.commit('AddIsLogin', 0);
            localStorage.removeItem('eleToken');
          });

        getScholarInfo()
          .then((res) => {
            if (res.status === 200) {
              if (res.data.success === true) {
                console.log(
                  'AddScholarLevel',
                  res.data.data?.item?.scholar_level,
                );
                context.commit(
                  'AddScholarLevel',
                  res.data.data?.item?.scholar_level,
                );
                context.commit('AddCurrentUserInfo', res.data.data?.item);
              } else {
                this.$message.error(res.data.message);
              }
            } else {
              this.$message.error('未请求成功');
              console.log('错误');
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log('没看到token');
        context.commit('AddIsLogin', 0);
        localStorage.removeItem('eleToken');
      }
    },
  },
};
